import { FC } from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import App from './App'
import NotFound from './pages/NotFound'

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <NotFound />,
  },
])

const Root: FC = () => {
  return <RouterProvider router={router} />
}

export default Root
